import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import calendericon from "../../assets/auth/calendericon.svg";
import mic from "../../assets/chatui/Microphone.svg";
import sent from "../../assets/chatui/IconSet.svg";
import TelegramIcon from "@mui/icons-material/Telegram";
import { attach, micicon, sendmessage } from "./chatsvgs.js";
import { Chip, Skeleton } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import api from "../../api/api";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MicNoneIcon from "@mui/icons-material/MicNone";
import SendIcon from "@mui/icons-material/Send";
import { use } from "react";
import { dateStringToCustomObject, formatmuiDate } from "../../dateutils/date";
import VoiceRecorder from "./voicerecorder";
import ToastMessage from "../../utils/mui/righttoptoast";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useScrollbarVisibility } from "../../utils/useScrollbarVisibility";
import { useSelector } from "react-redux";
import { ClampedText } from "./ClampedText.jsx";
import { eventBus } from "../../utils/eventBus.js";
import { getPracticeId, practiceFeatures, patientPhotoUrl, practiceShortName } from "../../config/practice";
import { enrollmentLink } from "../../utils/enrollmentLink";
import { appendQuickTag, postCallNote, quickTags } from "./callNotes";
import { isNoCallerReplyError, isNoCallerThread, NO_CALLER_BANNER, NO_CALLER_REPLY_ERROR } from "./noCallerThread";
import ProblemReportChip from "./ProblemReportChip";
import { useProblemReports } from "./problemReports";
import {
  messageLocationLabel,
  readThreadScope,
  replyDepartmentId,
  replyHintText,
  showsAllLocations,
  THREAD_THIS,
  threadScopeAvailable,
  threadScopeBody,
  threadScopeQuery,
  writeThreadScope,
} from "./chatLocation";
import ThreadScopeToggle from "./ThreadScopeToggle";

const PersonalChat = ({
  setToggleScreen,
  isNewPatient,
  top = "",
  patient,
  setchat,
}) => {
  const bottomRef = useRef(null);
  const isInitialLoadRef = useRef(true);
  const shouldScrollToBottomRef = useRef(false);
  const pendingPrependRef = useRef(null);
  const chatContainerRef = useRef(null);
  // State to manage messages and other variables
  const [selectedDate, setSelectedDate] = React.useState(dayjs());
  const [showCalendar, setShowCalendar] = useState(false); // State to show/hide calendar
  const [messages, setMessages] = useState([]);
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen,
  );
  // The "send enrollment form" link follows the header's location (CODE texts
  // CODE's intake; utils/enrollmentLink).
  const userConfig = useSelector((state) => state.userconfig);
  console.log(patient, "patient");
  const [previewUrls, setPreviewUrls] = useState({});
  const [dates, setDates] = useState([]);
  const practiseid = getPracticeId();
  const [inputText, setInputText] = useState("");
  const [isOnboarding, setIsonboading] = useState(false);
  const [isRecording, setIsRecording] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [offset, setOffset] = useState(0);
  const isProgrammaticScroll = useRef(false);
  const [openToast, setOpenToast] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [attachmentPreviewUrl, setAttachmentPreviewUrl] = useState(null);

  // Scrollbar visibility hook
  const { setupScrollListener } = useScrollbarVisibility();
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [chatdata, setChatData] = useState([]);
  // Thread view "This location" (default) / "All locations" (owner 11-04, chatLocation.js):
  // what the thread shows. The composer stays on the current location either way.
  const [threadScope, setThreadScope] = useState(readThreadScope);
  const allView = showsAllLocations(threadScope);
  const changeThreadScope = (next) => {
    writeThreadScope(next);
    setThreadScope(next);
  };
  // "All" refused (403: not a staff login of this practice): back to this location.
  const allRefused = (error) => {
    if (allView && error?.response?.status === 403) setThreadScope(THREAD_THIS);
  };
  const [chatloader, setChatLoader] = useState(false);
  // A reply the gateway refused (practice-number thread, 400 no_caller_id_thread):
  // shown inline under the box; the typed text stays (fax/chat/noCallerThread.js).
  const [replyError, setReplyError] = useState("");
  // Report-a-Problem chips (10-23): below chatdata, which it reads.
  const problemReports = useProblemReports(patient?.patientid, chatdata);
  // "Phone messages – no caller ID": nobody to reply to, so send is off there.
  // Call notes (7825) never text anyone and stay allowed.
  const noCallerThread = !practiceFeatures().callNotes && isNoCallerThread(patient);
  useEffect(() => {
    setReplyError("");
  }, [patient?.patientid]);

  const textareaRef = useRef(null);
  const MAX_ROWS = 4;
  const lineHeightRef = useRef(0);

  const autoResizeTextarea = () => {
    const ta = textareaRef.current;
    if (!ta) return;

    // Compute line-height once
    if (!lineHeightRef.current) {
      const cs = window.getComputedStyle(ta);
      lineHeightRef.current = parseFloat(cs.lineHeight || "24"); // fallback ~24px
    }

    // Reset then set to content height, but clamp to MAX_ROWS
    ta.style.height = "auto";
    const maxHeight = lineHeightRef.current * MAX_ROWS; // only content height; paddings are already in scrollHeight
    const newHeight = Math.min(ta.scrollHeight, maxHeight);
    ta.style.height = `${newHeight}px`;

    // Toggle scrolling past 4 rows
    ta.style.overflowY = ta.scrollHeight > maxHeight ? "auto" : "hidden";
  };

  useEffect(() => {
    autoResizeTextarea();
  }, [inputText]);

  const scrollToBottom = () => {
    if (!chatContainerRef.current) return;
    // best way: anchor
    bottomRef.current?.scrollIntoView({ behavior: "auto", block: "end" });
  };

  const capturePrependState = () => {
    const el = chatContainerRef.current;
    if (!el) return;
    pendingPrependRef.current = {
      prevScrollHeight: el.scrollHeight,
      prevScrollTop: el.scrollTop,
    };
  };

  useEffect(() => {
    if (!attachment) {
      setAttachmentPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(attachment);
    setAttachmentPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [attachment]);

  const restoreAfterPrepend = () => {
    const el = chatContainerRef.current;
    const snap = pendingPrependRef.current;
    if (!el || !snap) return;

    const newScrollHeight = el.scrollHeight;
    el.scrollTop = newScrollHeight - snap.prevScrollHeight + snap.prevScrollTop;

    pendingPrependRef.current = null;
  };

  useEffect(() => {
    if (chatContainerRef.current && offset === 0 && chatdata.length > 0) {
      const scrollToBottom = () => {
        isProgrammaticScroll.current = true;
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop =
            chatContainerRef.current.scrollHeight;
        }
        // Reset flag after scroll events settle
        setTimeout(() => {
          isProgrammaticScroll.current = false;
        }, 100);
      };

      // Multiple attempts to guarantee scroll reaches bottom after DOM paint
      scrollToBottom();
      requestAnimationFrame(() => {
        scrollToBottom();
        setTimeout(scrollToBottom, 100);
        setTimeout(scrollToBottom, 300);
      });
      setHasScrolled(false);
    }
  }, [chatdata, offset]);

  // Set up scroll listener for scrollbar visibility
  useEffect(() => {
    const el = chatContainerRef.current;
    if (!el) return;
    return setupScrollListener(el);
  }, [setupScrollListener, patient?.patientid]);
  const isDateAllowed = (date) => {
    // Check if the date is in the allowedDates array
    return dates.some((allowedDate) => allowedDate.isSame(date, "day"));
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  useEffect(() => {
    if (offset == 0) {
      return;
    }
    if (isToday(selectedDate)) {
      loadchat();
    }
  }, [offset]);

  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const handleDateChange = async (date) => {
    setSelectedDate(date);
    setShowCalendar(false);
    setOffset(0);

    try {
      const response = await api.post(
        `/v1/${practiseid}/messaging/chatdetails`,
        {
          patientid: patient.patientid,
          ...threadScopeBody(threadScope),
          limit: 50,
          offset: 0,
          start_date: dayjs(date).format("YYYY-MM-DD"),
          end_date: dayjs(date).format("YYYY-MM-DD"),
        },
      );

      if (response.status === 200) {
        shouldScrollToBottomRef.current = true; // ✅ force bottom
        setChatData(response.data.reverse());
      } else {
        setChatData([]);
      }
    } catch (e) {
      setChatData([]);
    }
  };

  const formatDate = (dateString) => {
    return dayjs(dateString).format("MM/DD/YYYY");
  };

  const fetchchat = async (x) => {
    setChatData([]);
    try {
      const response = await api.post(
        `/v1/${practiseid}/messaging/chatdetails`,
        {
          patientid: patient.patientid,
          ...threadScopeBody(threadScope),
          limit: 50,
          offset: x !== undefined && x !== null ? x : offset,

          // offset: x || offset,
        },
      );
      if (response.status === 200) {
        if ((x ?? offset) === 0) shouldScrollToBottomRef.current = true;
        setChatData(response.data.reverse());
      }
    } catch (error) {
      allRefused(error);
      console.log("error");
    } finally {
    }
  };
  const getDates = async () => {
    const response = await api.get(
      `/v1/${practiseid}/messaging/${patient.patientid}/chat-dates${threadScopeQuery(threadScope)}`,
    );
    if (response.status === 200) {
      setDates(response.data.map((date) => dayjs(date).startOf("day")));
    } else {
      setDates([]);
    }
  };

  const fetchDocument = async (attachmentFile) => {
    try {
      const timestamp = new Date().getTime(); // Generate a unique timestamp
      const response = await api.get(
        `/v1/${practiseid}/messaging/patient/${patient.patientid}/attachment/${attachmentFile}?_=${timestamp}`,
        { responseType: "blob" }, // Handle binary responses
      );
      console.log("response", response);

      if (response) {
        setPreviewUrls((prev) => ({
          ...prev,
          [attachmentFile]: URL.createObjectURL(response),
        }));
      }
    } catch (error) {
      const fallbackUrl = `https://cloud.brainymed.com/chim/storage/chat/${attachmentFile}`;
      setPreviewUrls((prev) => ({
        ...prev,
        [attachmentFile]: fallbackUrl,
      }));
      console.error("Error fetching the document:", error);
    }
  };

  const loadchat = async () => {
    try {
      capturePrependState();
      const response = await api.post(
        `/v1/${practiseid}/messaging/chatdetails`,
        {
          patientid: patient.patientid,
          ...threadScopeBody(threadScope),
          limit: 50,
          offset: offset,
        },
      );
      if (response.status === 200) {
        setChatData((prevData) => [...response.data.reverse(), ...prevData]);
      }
    } catch (error) {
      console.log("error");
    } finally {
    }
  };
  useEffect(() => {
    console.log(patient, "paatient");
    if (patient?.patientid) {
      getDates();

      fetchchat(0);
    }
  }, [patient]);
  // Switching the thread view reloads the thread (and its calendar dates) from today.
  const scopeMountedRef = useRef(false);
  useEffect(() => {
    if (!scopeMountedRef.current) {
      scopeMountedRef.current = true;
      return;
    }
    if (!patient?.patientid) return;
    setSelectedDate(dayjs());
    setOffset(0);
    getDates();
    fetchchat(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threadScope]);

  useLayoutEffect(() => {
    const el = chatContainerRef.current;
    if (!el) return;

    // 1) restore position after prepend
    if (pendingPrependRef.current) {
      restoreAfterPrepend();
      return;
    }

    // 2) initial load / date change / after send -> bottom
    if (shouldScrollToBottomRef.current) {
      shouldScrollToBottomRef.current = false;

      // do it twice: once now, once after images/layout settle
      scrollToBottom();
      requestAnimationFrame(scrollToBottom);
      setTimeout(scrollToBottom, 50);
    }
  }, [chatdata]);

  useEffect(() => {
    // if user hasn't manually scrolled away, keep them pinned to bottom when previews load
    if (!hasScrolled) {
      scrollToBottom();
      requestAnimationFrame(scrollToBottom);
    }
  }, [previewUrls]);

  const formattedDate = formatDate(selectedDate);

  // Function to handle sending a message
  const sendMessage = async () => {
    if (noCallerThread) {
      setReplyError(NO_CALLER_REPLY_ERROR);
      return;
    }
    setChatLoader(true);
    if (inputText.trim() || attachment) {
      let refused = false;
      try {
        const loginUser = localStorage.getItem("user"); // Set the dynamic value for login user
        const source = "practice"; // Set the dynamic value for source

        const data = {
          source: source, // Dynamically set the source
          message: inputText, // Dynamically set the message from inputText
          loginuser: loginUser, // Dynamically set the loginuser
        };
        // The inbox this conversation is in (9928): the reply is stamped with it.
        const replyDept = replyDepartmentId(patient);
        if (replyDept) data.departmentid = replyDept;

        const formData = new FormData();
        formData.append("data", JSON.stringify(data));
        if (attachment) {
          formData.append("attachment", attachment);
        }
        // Call notes (7825): v1 send-message, chat tables only -- never schat,
        // never the send-notification SMS below (fax/chat/callNotes.js).
        const response = practiceFeatures().callNotes
          ? await postCallNote(practiseid, patient.patientid, inputText, loginUser)
          : await api.post(
          `/v1/${practiseid}/messaging/patient/${patient.patientid}/schat`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if(response.status==200 && !practiceFeatures().callNotes){
            const encodedPatientId = btoa(String(patient.patientid)); // Base64 encode
           api.post(`/v1/${practiseid}/patient/messaging/send-notification`,{
            patskid:encodedPatientId,
            message:`New Message from ${practiceShortName()}`
          })
        }
        if (patient.unread_v2 === 1 && patient.is_reply === 0) {
          eventBus.emit("REFRESH_CHAT_LIST");
        }
      } catch (error) {
        if (isNoCallerReplyError(error)) {
          refused = true;
          setReplyError(NO_CALLER_REPLY_ERROR);
        }
        console.log(error);
      } finally {
        setChatLoader(false);
        shouldScrollToBottomRef.current = true;
        setOffset(0);
        fetchchat(0);
      }
      if (refused) return; // keep what was typed
      setReplyError("");
      setInputText("");
      setAttachment(null);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      sendMessage();
    }
  };
  // const handleScroll = () => {
  //   if (chatContainerRef.current.scrollTop === 0) {
  //     setOffset((prevOffset) => prevOffset+10); // Increment offset by 5 when scrolled to top
  //   }
  // };
  const handleScroll = () => {
    // Ignore scroll events triggered by our programmatic scrollToBottom
    if (isProgrammaticScroll.current) return;
    if (!chatContainerRef.current) return;

if (!hasScrolled) setHasScrolled(true);

    if (chatContainerRef.current.scrollTop === 0) {
      setOffset((prev) => prev + 50); // Load more messages
    }
  };
  const handleAttach = (e) => {
    const file = e.target.files[0];
    console.log(file, "file");
    if (file) {
      setAttachment(file);
    }
  };

  useEffect(() => {
    // Fetch previews for all attachments that are not yet fetched
    [...chatdata].reverse().forEach((message) => {
      if (message.attachement && !previewUrls[message.attachement]) {
        fetchDocument(message.attachement);
      }
    });
  }, [chatdata]);
  // "{name} is Typing..." lock. Unlock the patient this textarea locked, not
  // whichever patient is selected now: a send refreshes the list, which can
  // switch the conversation while the textarea still has focus, and the blur
  // then unlocked the new patient and left the old one locked for good. The
  // server also expires a lock after LOCK_TTL_SECONDS (api chat_lock.py).
  const lockedPatientRef = useRef(null);
  const detecttype = async (status) => {
    let pid = patient?.patientid;
    if (status === "unlock") {
      pid = lockedPatientRef.current;
      lockedPatientRef.current = null;
    } else if (pid) {
      lockedPatientRef.current = pid;
    }
    if (!pid) return;
    try {
      await api.put(`/v1/${practiseid}/messaging/${pid}/lock-status/${status}`);
    } catch (e) {
      // cosmetic only; the server-side expiry clears a lock we fail to release
    }
  };
  // Release the lock when the conversation changes or the chat closes while the
  // textarea is still focused (unmounting it never fires onBlur).
  useEffect(() => {
    return () => {
      if (lockedPatientRef.current) detecttype("unlock");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient?.patientid]);
  const formatDateHeading = (dateString) => {
    // Parse the input date string
    const [datePart] = dateString.split("T");
    const [year, month, day] = datePart.split("-").map(Number);

    // Get today's date manually
    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1; // Months are zero-based
    const todayDay = today.getDate();

    // Get yesterday's date manually
    const yesterday = new Date(today);
    yesterday.setDate(todayDay - 1);
    const yesterdayYear = yesterday.getFullYear();
    const yesterdayMonth = yesterday.getMonth() + 1;
    const yesterdayDay = yesterday.getDate();

    // Compare the parsed date with today and yesterday
    if (year === todayYear && month === todayMonth && day === todayDay) {
      return "Today";
    } else if (
      year === yesterdayYear &&
      month === yesterdayMonth &&
      day === yesterdayDay
    ) {
      return "Yesterday";
    } else {
      // Format the date manually as "12 August 2024"
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return `${day} ${months[month - 1]} ${year}`;
    }
  };

  const isToday = (date) => {
    const today = new Date();
    const checkDate = new Date(date);
    return (
      today.getDate() === checkDate.getDate() &&
      today.getMonth() === checkDate.getMonth() &&
      today.getFullYear() === checkDate.getFullYear()
    );
  };
  const submitOnBoardingForm = async ({ ph, msg }) => {
    setIsonboading(true);
    try {
      const response = await api.post(
        // This conversation's patient, not a placeholder: the route used to text the
        // stored phone of the patientid in the URL (6 = a real chart), not `phone`.
        `/v1/${practiseid}/patient/${patient.patientid}/notification/send-sms`,
        {
          message: enrollmentLink(userConfig?.config),
          phone: patient.mobilephone,
        },
      );
      if (response.status === 200) {
        setToastMessage(response.message);
        setToastSeverity("success");
        setOpenToast(true);
      } else {
        setToastMessage(response.message);
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      // The gateway never texts a practice number (no-caller thread): say so inline.
      if (isNoCallerReplyError(error)) setReplyError(NO_CALLER_REPLY_ERROR);
      console.log(error);
    } finally {
      setIsonboading(false);
    }
  };

  const onChipdelete = async () => {
    setSelectedDate(dayjs());
    setOffset(0);
    const response = await api.post(`/v1/${practiseid}/messaging/chatdetails`, {
      patientid: patient.patientid,
      ...threadScopeBody(threadScope),
      limit: 50,
      offset: 0,
    });
    if (response.status === 200) {
      setChatData(response.data.reverse());
    }
  };
  // Track the current date heading
  let lastDate = "";
  // Call notes (7825): the list no longer opens its first conversation by
  // itself, so say so until one is picked.
  if (practiceFeatures().callNotes && !patient?.patientid) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full min-h-[200px] text-center" data-testid="no-patient-selected">
        <div className="text-[#1D2951] text-[15px] font-semibold">No Patient Selected</div>
      </div>
    );
  }
  return (
    <div
      className={`flex relative flex-col w-full ${top === "inline" ? "h-full" : "h-auto"} ${top === "" ? "border-l-2 border-[#FFEAD1]" : ""}`}
    >
      {/* Header */}
      {top !== "inline" && <div
        className="absolute cursor-pointer right-4 top-2 z-50"
        onClick={() => setchat(false)}
      >
        <FontAwesomeIcon icon={faXmark} size="xl" />
      </div>}
      <div className={top === "inline" ? "bg-white w-full sticky top-0 z-10" : "fixed bg-white w-[440px] z-10"}>

        <div
          className="flex  w-[100%] items-center justify-between p-3"
          style={{ borderBottom: "1px solid var(--Stroke, #F1F3F9)" }}
        >
          <div className="flex items-center gap-2">
            <img
              src={patientPhotoUrl(patient.patientid)}
              alt="profile"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              onError={(e) =>
                (e.target.src =
                  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
              }
            />
            <div>
              <div className="font-inter text-[14px]">
                {patient?.patientname ||
                  `${patient?.firstname || ""} ${patient?.lastname || ""}`}
              </div>

              <div className="flex items-center gap-2 flex-wrap font-inter text-[14px]">
                <span className="text-[#B6BFE8]">
                  {patient?.patientid || ""}
                </span>

                {patient.tags &&
                  patient.tags.split(",").map((tag, index) => (
                    <div
                      key={index}
                      className="bg-[#D97842] text-white px-2 py-1 rounded-full text-xs"
                    >
                      {tag.trim().charAt(0).toUpperCase() + tag.trim().slice(1)}
                    </div>
                  ))}
              </div>
              {noCallerThread && (
                <div
                  className="mt-1 px-2 py-1 text-[12px] leading-snug text-[#7A4B00] bg-[#FFF4E0] border border-[#FFD8A8] rounded-md"
                  data-testid="no-caller-banner"
                  role="status"
                >
                  {NO_CALLER_BANNER}
                </div>
              )}
            </div>
          </div>
          <div
            className={`flex gap-2  items-end ml-[${
              isToday(selectedDate) ? "200px" : "120px"
            }]`}
          >
            {!isToday(selectedDate) && (
              <Chip
                label={formatDate(selectedDate)}
                onDelete={() => onChipdelete()}
                color="primary"
                variant="outlined"
              />
            )}
            <div className="flex flex-col items-center justify-center">
              {dates.length ? (
                <img
                  src={calendericon}
                  className="h-6 w-6 cursor-pointer"
                  alt="calendar icon"
                  onClick={() => setShowCalendar(!showCalendar)}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {patient?.patientid && threadScopeAvailable() ? (
          <div
            className="flex items-center px-3 py-1"
            style={{ borderBottom: "1px solid var(--Stroke, #F1F3F9)" }}
          >
            <ThreadScopeToggle value={threadScope} onChange={changeThreadScope} />
          </div>
        ) : null}
      </div>

      {/* First attachment + input block (Drawer mode only) */}
      {top !== "inline" && (<>
      {/* atchatment Area */}
      {attachment ? (
        <div className={`flex justify-evenly items-start p-1 mb-2 bg-white ${top === "inline" ? "w-full sticky bottom-2" : "w-[424px] fixed bottom-2"}`}>
          {attachment.type.startsWith("image/") ? (
            // Image Attachment Preview
            <img
              src={URL.createObjectURL(attachment)}
              alt="Attachment Preview"
              className="h-44 w-20 object-cover rounded-lg"
            />
          ) : attachment.type === "application/pdf" ? (
            <>
              {/* <div className="flex mb-4 space-x-2"> */}
              <div className="h-20 w-20">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-6 h-6 text-red-600"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
                <a
                  href={URL.createObjectURL(attachment)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500  underline"
                >
                  View PDF: {attachment.name}
                </a>
              </div>
            </>
          ) : attachment.type === "audio/mpeg" ||
            attachment.type === "audio/wav" ? (
            <>
              <div className="h-20 w-20 flex items-center space-x-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-6 h-6 text-green-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 19V5l12 7-12 7z"
                  />
                </svg>
              </div>
            </>
          ) : (
            <> </>
          )}

          <div className="text-sm font-sans">
            File Attached: {attachment.name}
          </div>
          <ClearIcon onClick={() => setAttachment(null)} />
        </div>
      ) : null}

      {/* recording */}
      {!isRecording ? (
        <div
          className={`${practiceFeatures().callNotes ? "flex-wrap " : ""}flex gap-2 items-center justify-between p-3 bg-white ${top === "inline" ? "w-full sticky bottom-0" : "w-[440px] fixed bottom-0"}  ${
            patient.flow === "newpt" ? "opacity-50 pointer-events-none" : ""
          }  ${
            Object.keys(patient).length === 0
              ? "opacity-50 pointer-events-none cursor-not-allowed"
              : ""
          }`}
          style={{ borderTop: "1px solid var(--Stroke, #F1F3F9)" }}
        >
          {replyError && (
            <div
              className="w-full px-3 py-1.5 text-[12px] text-[#B42318] bg-[#FEF3F2] border border-[#FECDCA] rounded-lg"
              data-testid="reply-error"
              role="alert"
            >
              {replyError}
            </div>
          )}
          {/* "All locations" view: the reply still goes to the current location's thread. */}
          {allView && (
            <div
              data-testid="reply-location-hint"
              className="w-full px-1 pb-1 text-[11px] leading-4 text-[#5B6B8C] font-font1"
            >
              {replyHintText(patient, userConfig?.config)}
            </div>
          )}
          {/* Quick tags (call notes, 7825): a chip appends its text. */}
          {practiceFeatures().callNotes && (
            <div className="w-full flex items-center gap-1.5 overflow-x-auto pb-1" data-testid="quick-tags">
              {quickTags().map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => setInputText((prev) => appendQuickTag(prev, tag))}
                  className="px-2.5 py-0.5 bg-[#F1F5F9] hover:bg-[#E2E8F0] text-[#334155] text-[11px] font-semibold rounded-full border border-[#CBD5E1]/60 flex-shrink-0"
                >
                  + {tag}
                </button>
              ))}
            </div>
          )}
          <div
            style={{
              borderRadius: "14px",
              background: "#F7F9FB", // matches var(--color-grey-98)
              pointerEvents: (practiceFeatures().callNotes || homescreenprev.includes("Lock Messages"))
                ? "auto"
                : "none",
              boxShadow:
                "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
            }}
            className="flex items-center border w-full gap-3 px-2 border-[#D5D5D5]"
          >
            <textarea
              ref={textareaRef}
              rows={1}
              type="text"
              className="bg-transparent flex-grow py-1 pl-2 pr-3 text-base outline-none rounded-[14px] resize-none"
              placeholder={practiceFeatures().callNotes ? "Type a call note..." : "Type a message..."}
              value={inputText}
              disabled={patient.flow === "newpt" || noCallerThread}
              onChange={(e) => {
                setInputText(e.target.value);
                autoResizeTextarea();
              }}
              onKeyDown={handleKeyDown}
              onFocus={() => {
                detecttype("lock");
                // ensure correct height on focus too
                autoResizeTextarea();
              }}
              onBlur={() => detecttype("unlock")}
              // Provide an initial max height so there’s no jump before first resize
              style={{
                maxHeight: lineHeightRef.current
                  ? `${lineHeightRef.current * MAX_ROWS}px`
                  : undefined,
                overflowY: "hidden",
              }}
            />

            {chatloader ? (
              <div className="flex items-center justify-center w-8 h-8">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 100"
                  width="24"
                  height="24"
                  className="animate-spin text-blue-500"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke="#007bff"
                    strokeWidth="5"
                    fill="none"
                    strokeDasharray="283"
                    strokeDashoffset="75"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            ) : (
              <div className="h-auto mt-2">
                <div
                  onClick={patient.flow === "newpt" || noCallerThread ? undefined : sendMessage}
                  data-testid="send-button"
                  aria-disabled={patient.flow === "newpt" || noCallerThread}
                  style={{
                    pointerEvents: patient.flow === "newpt" ? "none" : "auto",
                    opacity: patient.flow === "newpt" || noCallerThread ? 0.5 : 1,
                    borderRadius: "4px",
                    cursor:
                      patient.flow === "newpt" || noCallerThread ? "not-allowed" : "pointer",
                    pointerEvents: (practiceFeatures().callNotes || homescreenprev.includes("Lock Messages"))
                      ? "auto"
                      : "none",
                  }}
                  className="inline-block"
                >
                  {sendmessage}
                </div>
              </div>
            )}
            {/* No attachments on call notes (7825). */}
            {!practiceFeatures().callNotes && (<>
            <input
              type="file"
              accept=".pdf,.png,.jpeg,.jpg,.doc,.docx,.xls,.xlsx,.txt,.csv,.mp3,.wav,.mp4,.avi,.mov,.zip,.rar"
              className="hidden"
              disabled={patient.flow === "newpt"}
              onChange={(e) => {
                handleAttach(e);
                e.target.value = null; // Reset the input value
              }}
              id="fileInput"
            />

            <label
              htmlFor="fileInput"
              className={
                patient.flow === "newpt"
                  ? "pointer-events-none cursor-not-allowed opacity-50"
                  : ""
              }
            >
              <div className="  text-red-500 cursor-pointer mt-[11px]">
                {attach}
              </div>
            </label>
            </>)}
            <div className="mt-[3px]">
              <div
                onClick={
                  patient.flow === "newpt"
                    ? undefined
                    : () => {
                        setInputText("");
                        setIsRecording(true);
                      }
                }
                style={{
                  pointerEvents:
                    (practiceFeatures().callNotes || homescreenprev.includes("Lock Messages")) &&
                    patient.flow !== "newpt"
                      ? "auto"
                      : "none",
                  opacity: patient.flow === "newpt" ? 0.5 : 1,
                  cursor: patient.flow === "newpt" ? "not-allowed" : "pointer",
                }}
              >
                {micicon}
              </div>
            </div>
          </div>

          {/* Hidden file input */}
        </div>
      ) : (
        <>
          <div
            className={`flex gap-2 items-center p-4 bg-white ${top === "inline" ? "w-full sticky bottom-0" : "w-[440px] fixed bottom-0"}`}
            style={{ borderTop: "1px solid var(--Stroke, #F1F3F9)" }}
          >
            <VoiceRecorder
              isStartRecording={isRecording}
              setTranscript={setInputText} // Make sure this line exists
              patient={patient}
              text={inputText}
              setIsRecord={setIsRecording}
              fetchchat={fetchchat}
            />
          </div>
        </>
      )}
      </>)}
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />

      {/* Calendar Popup */}
      {showCalendar && (
        <div
          className="absolute top-[15%] right-[7%] z-50"
          style={{ maxWidth: "300px", width: "300px" }}
        >
          <DatePicker
            selected={selectedDate.toDate()}
            onChange={(date) => handleDateChange(dayjs(date))}
            filterDate={(date) => isDateAllowed(dayjs(date))}
            inline
            calendarClassName="custom-calendar personal-chat-calendar"
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={15}
            dateFormat="MM/dd/yyyy"
          />
          <style>{`
            .personal-chat-calendar.custom-calendar {
              background-color: white;
              border-radius: 10px;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              padding: 16px;
              font-family: inherit;
              width: 100%;
            }
            .personal-chat-calendar .react-datepicker__header {
              background-color: white;
              border-bottom: none;
              padding: 0 0 12px 0;
            }
            .personal-chat-calendar .react-datepicker__current-month {
              font-size: 15px;
              font-weight: 500;
              color: #1D2951;
              margin-bottom: 0;
              padding-bottom: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 20px !important;
            }
            .personal-chat-calendar .react-datepicker__current-month select {
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              background: white;
              border: none;
              font-size: 15px;
              font-weight: 500;
              color: #1D2951;
              cursor: pointer;
              padding-right: 28px;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
              background-repeat: no-repeat;
              background-position: right center;
              background-size: 10px 6px;
              outline: none;
            }
            .personal-chat-calendar .react-datepicker__current-month select:focus,
            .personal-chat-calendar .react-datepicker__current-month select:active,
            .personal-chat-calendar .react-datepicker__current-month select:hover {
              outline: none;
              box-shadow: none;
              color: #1D2951;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            }
            .personal-chat-calendar .react-datepicker__month-dropdown,
            .personal-chat-calendar .react-datepicker__year-dropdown {
              background-color: white;
              border: 1px solid #e5e7eb;
              border-radius: 6px;
              padding: 4px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              max-height: 200px;
              overflow-y: auto;
            }
            .personal-chat-calendar .react-datepicker__year-dropdown {
              height: 260px;
              max-height: 260px;
            }
            .personal-chat-calendar .react-datepicker__month-option,
            .personal-chat-calendar .react-datepicker__year-option {
              padding: 6px 12px;
              cursor: pointer;
              font-size: 14px;
              border-radius: 4px;
              outline: none;
              color: #1D2951;
            }
            .personal-chat-calendar .react-datepicker__month-option:focus,
            .personal-chat-calendar .react-datepicker__year-option:focus {
              outline: none;
              box-shadow: none;
            }
            .personal-chat-calendar .react-datepicker__month-option:hover,
            .personal-chat-calendar .react-datepicker__year-option:hover {
              background-color: #f3f4f6;
            }
            .personal-chat-calendar .react-datepicker__month-option--selected,
            .personal-chat-calendar .react-datepicker__year-option--selected {
              background-color: #1D2951;
              color: white;
            }
            .personal-chat-calendar .react-datepicker__day-names {
              display: flex;
              justify-content: space-around;
              margin-bottom: 8px;
              padding-top: 8px;
            }
            .personal-chat-calendar .react-datepicker__day-name {
              width: 36px;
              line-height: 36px;
              margin: 0;
              color: #6b7280;
              font-size: 12px;
              font-weight: 500;
              text-align: center;
            }
            .personal-chat-calendar .react-datepicker__month { margin: 0; padding: 0; }
            .personal-chat-calendar .react-datepicker__week {
              display: flex;
              justify-content: space-around;
              margin-bottom: 4px;
            }
            .personal-chat-calendar .react-datepicker__day {
              width: 34px;
              height: 34px;
              line-height: 36px;
              margin: 0;
              border-radius: 50%;
              color: #111827;
              font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .personal-chat-calendar .react-datepicker__day:hover {
              background-color: #f3f4f6;
              border-radius: 50%;
            }
            .personal-chat-calendar .react-datepicker__day--selected,
            .personal-chat-calendar .react-datepicker__day--keyboard-selected {
              background-color: #1D2951 !important;
              color: white !important;
              border-radius: 50%;
              font-weight: 500;
            }
            .personal-chat-calendar .react-datepicker__day--selected:hover,
            .personal-chat-calendar .react-datepicker__day--keyboard-selected:hover {
              background-color: #1D2951 !important;
            }
            .personal-chat-calendar .react-datepicker__day--today {
              font-weight: 600;
              border: 1px solid #1D2951;
              border-radius: 50%;
              box-sizing: border-box;
            }
            .personal-chat-calendar .react-datepicker__day--outside-month {
              color: #d1d5db;
            }
            .personal-chat-calendar .react-datepicker__day--disabled {
              color: #d1d5db;
              cursor: not-allowed;
            }
            .personal-chat-calendar .react-datepicker__navigation {
              top: 16px;
              outline: none;
              width: 32px;
              height: 32px;
              border-radius: 4px;
            }
            .personal-chat-calendar .react-datepicker__navigation:hover {
              background-color: #f3f4f6;
            }
            .personal-chat-calendar .react-datepicker__navigation:focus {
              outline: none;
              box-shadow: none;
            }
            .personal-chat-calendar .react-datepicker__navigation-icon::before {
              border-color: #111827;
              border-width: 2px 2px 0 0;
            }
          `}</style>
        </div>
      )}
      {/* </div> */}

      {/* Chat Messages Area */}
      <div
        className={`flex-1 overflow-y-auto p-2 pl-4 w-full ${top === "inline" ? "" : "sm:max-h-[calc(100vh-28vh-50px)] max-h-full"}`}
        ref={chatContainerRef}
        onScroll={handleScroll}
        style={top === "inline" ? {} : {
          marginTop: "120px",
          marginBottom: "50px",
        }}
      >
        {Object.keys(patient).length === 0 ? (
          <div className="flex items-center justify-center  h-full text-sm text-gray-500 text-center px-4">
            <div className="flex items-center justify-center ">
              <div className="w-full text-center">
                No patient is currently selected
              </div>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100"
                width="24"
                height="24"
                className="animate-spin text-blue-500"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  stroke="#007bff"
                  strokeWidth="5"
                  fill="none"
                  strokeDasharray="283"
                  strokeDashoffset="75"
                  strokeLinecap="round"
                />
              </svg> */}
            </div>
          </div>
        ) : (
          <>
            {/* Message indicating no previous chats before the first date shown */}
            {chatdata.length === 0 && (
              <div className="text-[#121212] text-base text-center mb-2 mt-1">
                No chats found
              </div>
            )}
            {chatdata.map((message, index, arr) => {
              const currentDate = message.created_on.split("T")[0]; // Split at "T" and get the date part

              // Format the current date into the desired format
              const dateHeading = formatDateHeading(currentDate);

              // Show date heading if it's different from the lastDate
              const showDateHeading = lastDate !== currentDate;

              // Update lastDate after checking
              lastDate = currentDate;
              const isHtmlMessage =
                message.msg_tags === "newpt" || /<[^>]+>/.test(message.message);

              return (
                <div key={index}>
                  {showDateHeading && (
                    <div className="text-gray-500 text-sm text-center mb-2">
                      {dateHeading}
                    </div>
                  )}
                  <div
                    className={`mb-4 w-full ${
                      message.is_reply == 1
                        ? "flex justify-start"
                        : "flex justify-end"
                    }`}
                  >
                    <div
                      className={`flex flex-col break-words text-left ${
                        message.msg_tags === "newpt"
                          ? "bg-gray-200 text-white"
                          : message.is_reply === 1
                            ? "bg-[#E17954] text-white  rounded-tl-[16px] rounded-tr-[16px]  rounded-br-[16px] px-3 pt-3 pb-1"
                            : "bg-[#E5E7EB] text-[#1C1D22] rounded-tl-[16px] rounded-bl-[16px] rounded-tr-[16px] p-2"
                      }  ${isHtmlMessage ? "w-[92%] px-1" : isNewPatient ? "w-[85%]" : "w-[70%]"}  mb-1`}
                    >
                      {message.is_reply === 2 ? (
                        <span
                          style={{ alignSelf: "start" }}
                          className={`text-[14px] mb-1 font-medium font-font1 ${
                            message.is_reply === 1
                              ? "text-white"
                              : "text-[#193EB9]"
                          }`}
                        >
                          {message.created_by}
                        </span>
                      ) : (
                        <span>{message.created_by}</span>
                      )}
                      {messageLocationLabel(message, threadScope) && (
                        <span
                          data-testid="message-location"
                          style={{ alignSelf: "start" }}
                          className="mb-1 rounded px-1 text-[10px] leading-4 font-font1 bg-[#E8EEF7] text-[#24578F]"
                        >
                          {messageLocationLabel(message, threadScope)}
                        </span>
                      )}
                      {problemReports.reportFor(message) && (
                        <ProblemReportChip
                          report={problemReports.reportFor(message)}
                          onResolved={problemReports.markResolved}
                        />
                      )}
                      {message.attachement ? (
                        previewUrls[message.attachement] ? (
                          typeof message.attachement === "string" &&
                          !message.attachement.endsWith(".pdf") &&
                          !message.attachement.endsWith(".mp3") ? (
                            <>
                              <a
                                href={previewUrls[message.attachement]}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group"
                              >
                                <img
                                  src={previewUrls[message.attachement]}
                                  alt="Attachment Preview"
                                  className="h-32 w-32 object-cover rounded-lg mb-2 transition-transform duration-200 ease-in-out group-hover:scale-105"
                                />
                              </a>

                              {/* Message Text */}
                              <div className="text-sm text-gray-800">
                                {message.message && (
                                  <p className="truncate">
                                    {message.message
                                      .replace(
                                        "(attachment sent)(attachment sent)",
                                        "",
                                      )
                                      .trim()}
                                  </p>
                                )}
                              </div>
                            </>
                          ) : message.attachement.endsWith(".mp3") ? (
                            <div className="group">
                              <audio controls className="w-full">
                                <source
                                  src={previewUrls[message.attachement]}
                                  type="audio/mp3"
                                />
                                Your browser does not support the audio element.
                              </audio>
                            </div>
                          ) : (
                            <a
                              href={previewUrls[message.attachement]}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center space-x-2 p-2 bg-gray-100 hover:bg-gray-200 rounded-lg"
                            >
                              {/* Icon for the document */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                className="w-6 h-6 text-gray-700"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
                                />
                              </svg>

                              {/* File Name with Action Text */}
                              <div className="flex flex-col">
                                <span className="text-sm font-medium text-gray-800">
                                  {message.attachement}
                                </span>
                                <span className="text-xs text-blue-500">
                                  View Document
                                </span>
                              </div>
                            </a>
                          )
                        ) : (
                          <div>
                            <Skeleton
                              variant="text"
                              width={150}
                              height={20}
                              animation="wave"
                              style={{ display: "inline-block" }}
                            />
                          </div>
                        )
                      ) : message.msg_tags === "newpt" ||
                        /<[^>]+>/.test(message.message) ? (
                        <>
                          <div
                            onClick={(e) => {
                              if (
                                e.target.classList.contains(
                                  "sendPatientEnrollmentForm",
                                )
                              ) {
                                // The link is C-HIM's high-bp.com enrollment page (9928 only).
                                if (!isOnboarding && practiceFeatures().websiteLeads) {
                                  submitOnBoardingForm({ ph: message });
                                }
                              }
                            }}
                            style={{
                              background: "#fff",
                              borderRadius: "12px",
                              padding: "10px",
                              maxWidth: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "14px",
                                color: "#1C1D22",
                                wordBreak: "break-word",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: message.message,
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        // )  : (<div className={` text-[14px] font-light font-font1 ${message.is_reply === 1 ? 'text-white' : 'ml-2 text-[#1C1D22]'}`}>
                        // {message.message}
                        //   </div>

                        // )
                        <ClampedText
                          text={message.message}
                          user={message.is_reply}
                          className={`text-[14px] font-light font-font1 ${
                            message.is_reply === 1
                              ? "text-white"
                              : "ml-2 text-[#1C1D22]"
                          }`}
                        />
                      )}
                      <span
                        style={{ alignSelf: "end" }}
                        className={`text-[10px] ${
                          message.msg_tags === "newpt" ||
                          /<[^>]+>/.test(message.message)
                            ? "text-[#1D2951] mt-1"
                            : message.is_reply === 1
                              ? "text-white"
                              : "text-[#1D2951]"
                        } font-inter mt-2`}
                      >
                        {new Date(message.created_on).toLocaleString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
            <div ref={bottomRef} />
          </>
        )}
      </div>

      {/* atchatment Area */}
      {attachment ? (
        <div className={`flex justify-evenly items-start p-1 mb-2 bg-white ${top === "inline" ? "w-full sticky bottom-2" : "w-[424px] fixed bottom-2"}`}>
          {attachment.type.startsWith("image/") ? (
            // Image Attachment Preview
            <img
              src={URL.createObjectURL(attachment)}
              alt="Attachment Preview"
              className="h-44 w-20 object-cover rounded-lg"
            />
          ) : attachment.type === "application/pdf" ? (
            <>
              {/* <div className="flex mb-4 space-x-2"> */}
              <div className="h-20 w-20">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-6 h-6 text-red-600"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
                <a
                  href={URL.createObjectURL(attachment)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500  underline"
                >
                  View PDF: {attachment.name}
                </a>
              </div>
            </>
          ) : attachment.type === "audio/mpeg" ||
            attachment.type === "audio/wav" ? (
            <>
              <div className="h-20 w-20 flex items-center space-x-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-6 h-6 text-green-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 19V5l12 7-12 7z"
                  />
                </svg>
              </div>
            </>
          ) : (
            <> </>
          )}

          <div className="text-sm font-sans">
            File Attached: {attachment.name}
          </div>
          <ClearIcon onClick={() => setAttachment(null)} />
        </div>
      ) : null}

      {/* recording */}
      {!isRecording ? (
        <div
          className={`${practiceFeatures().callNotes ? "flex-wrap " : ""}flex gap-2 items-center justify-between p-3 bg-white ${top === "inline" ? "w-full sticky bottom-0" : "w-[440px] fixed bottom-0"}  ${
            patient.flow === "newpt" ? "opacity-50 pointer-events-none" : ""
          }  ${
            Object.keys(patient).length === 0
              ? "opacity-50 pointer-events-none cursor-not-allowed"
              : ""
          }`}
          style={{ borderTop: "1px solid var(--Stroke, #F1F3F9)" }}
        >
          {replyError && (
            <div
              className="w-full px-3 py-1.5 text-[12px] text-[#B42318] bg-[#FEF3F2] border border-[#FECDCA] rounded-lg"
              data-testid="reply-error"
              role="alert"
            >
              {replyError}
            </div>
          )}
          {/* "All locations" view: the reply still goes to the current location's thread. */}
          {allView && (
            <div
              data-testid="reply-location-hint"
              className="w-full px-1 pb-1 text-[11px] leading-4 text-[#5B6B8C] font-font1"
            >
              {replyHintText(patient, userConfig?.config)}
            </div>
          )}
          {/* Quick tags (call notes, 7825): a chip appends its text. */}
          {practiceFeatures().callNotes && (
            <div className="w-full flex items-center gap-1.5 overflow-x-auto pb-1" data-testid="quick-tags">
              {quickTags().map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => setInputText((prev) => appendQuickTag(prev, tag))}
                  className="px-2.5 py-0.5 bg-[#F1F5F9] hover:bg-[#E2E8F0] text-[#334155] text-[11px] font-semibold rounded-full border border-[#CBD5E1]/60 flex-shrink-0"
                >
                  + {tag}
                </button>
              ))}
            </div>
          )}
          <div
            style={{
              borderRadius: "14px",
              background: "#F7F9FB",
              boxShadow:
                "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
            }}
            className="flex items-center border w-full gap-3 px-2 border-[#D5D5D5]"
          >
            <textarea
              ref={textareaRef}
              rows={1}
              type="text"
              className="bg-transparent flex-grow py-1 pl-2 pr-3 text-base outline-none rounded-[14px] resize-none"
              placeholder={practiceFeatures().callNotes ? "Type a call note..." : "Type a message..."}
              value={inputText}
              disabled={patient.flow === "newpt" || noCallerThread}
              onChange={(e) => {
                setInputText(e.target.value);
                autoResizeTextarea();
              }}
              onKeyDown={handleKeyDown}
              onFocus={() => {
                detecttype("lock");
                // ensure correct height on focus too
                autoResizeTextarea();
              }}
              onBlur={() => detecttype("unlock")}
              // Provide an initial max height so there’s no jump before first resize
              style={{
                maxHeight: lineHeightRef.current
                  ? `${lineHeightRef.current * MAX_ROWS}px`
                  : undefined,
                overflowY: "hidden",
              }}
            />

            {chatloader ? (
              <div className="flex items-center justify-center w-8 h-8">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 100"
                  width="24"
                  height="24"
                  className="animate-spin text-blue-500"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke="#007bff"
                    strokeWidth="5"
                    fill="none"
                    strokeDasharray="283"
                    strokeDashoffset="75"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            ) : (
              <div className="h-auto mt-2">
                <div
                  onClick={patient.flow === "newpt" || noCallerThread ? undefined : sendMessage}
                  data-testid="send-button"
                  aria-disabled={patient.flow === "newpt" || noCallerThread}
                  style={{
                    pointerEvents: patient.flow === "newpt" ? "none" : "auto",
                    opacity: patient.flow === "newpt" || noCallerThread ? 0.5 : 1,
                    borderRadius: "4px",
                    cursor:
                      patient.flow === "newpt" || noCallerThread ? "not-allowed" : "pointer",
                  }}
                  className="inline-block"
                >
                  {sendmessage}
                </div>
              </div>
            )}
            {/* No attachments on call notes (7825). */}
            {!practiceFeatures().callNotes && (<>
            <input
              type="file"
              accept=".pdf,.png,.jpeg,.jpg,.doc,.docx,.xls,.xlsx,.txt,.csv,.mp3,.wav,.mp4,.avi,.mov,.zip,.rar"
              className="hidden"
              disabled={patient.flow === "newpt"}
              onChange={(e) => {
                handleAttach(e);
                e.target.value = null; // Reset the input value
              }}
              id="fileInput"
            />

            <label
              htmlFor="fileInput"
              className={
                patient.flow === "newpt"
                  ? "pointer-events-none cursor-not-allowed opacity-50"
                  : ""
              }
            >
              <div className="  text-red-500 cursor-pointer mt-[11px]">
                {attach}
              </div>
            </label>
            </>)}
            <div className="mt-[3px]">
              <div
                onClick={
                  patient.flow === "newpt"
                    ? undefined
                    : () => {
                        setInputText("");
                        setIsRecording(true);
                      }
                }
                style={{
                  pointerEvents: patient.flow === "newpt" ? "none" : "auto",
                  opacity: patient.flow === "newpt" ? 0.5 : 1,
                  cursor: patient.flow === "newpt" ? "not-allowed" : "pointer",
                }}
              >
                {micicon}
              </div>
            </div>
          </div>

          {/* Hidden file input */}
        </div>
      ) : (
        <>
          <div
            className={`flex gap-2 items-center p-4 bg-white ${top === "inline" ? "w-full sticky bottom-0" : "w-[440px] fixed bottom-0"}`}
            style={{ borderTop: "1px solid var(--Stroke, #F1F3F9)" }}
          >
            <VoiceRecorder
              isStartRecording={isRecording}
              setTranscript={setInputText}
              text={inputText}
              patient={patient}
              setIsRecord={setIsRecording}
              fetchchat={fetchchat}
            />
          </div>
        </>
      )}
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />

      {/* Calendar Popup */}
      {showCalendar && (
        <div
          className="absolute top-[15%] right-[7%] z-50"
          style={{ maxWidth: "300px", width: "300px" }}
        >
          <DatePicker
            selected={selectedDate.toDate()}
            onChange={(date) => handleDateChange(dayjs(date))}
            filterDate={(date) => isDateAllowed(dayjs(date))}
            inline
            calendarClassName="custom-calendar personal-chat-calendar"
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={15}
            dateFormat="MM/dd/yyyy"
          />
          <style>{`
            .personal-chat-calendar.custom-calendar {
              background-color: white;
              border-radius: 10px;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              padding: 16px;
              font-family: inherit;
              width: 100%;
            }
            .personal-chat-calendar .react-datepicker__header {
              background-color: white;
              border-bottom: none;
              padding: 0 0 12px 0;
            }
            .personal-chat-calendar .react-datepicker__current-month {
              font-size: 15px;
              font-weight: 500;
              color: #1D2951;
              margin-bottom: 0;
              padding-bottom: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 20px !important;
            }
            .personal-chat-calendar .react-datepicker__current-month select {
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              background: white;
              border: none;
              font-size: 15px;
              font-weight: 500;
              color: #1D2951;
              cursor: pointer;
              padding-right: 28px;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
              background-repeat: no-repeat;
              background-position: right center;
              background-size: 10px 6px;
              outline: none;
            }
            .personal-chat-calendar .react-datepicker__current-month select:focus,
            .personal-chat-calendar .react-datepicker__current-month select:active,
            .personal-chat-calendar .react-datepicker__current-month select:hover {
              outline: none;
              box-shadow: none;
              color: #1D2951;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            }
            .personal-chat-calendar .react-datepicker__month-dropdown,
            .personal-chat-calendar .react-datepicker__year-dropdown {
              background-color: white;
              border: 1px solid #e5e7eb;
              border-radius: 6px;
              padding: 4px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              max-height: 200px;
              overflow-y: auto;
            }
            .personal-chat-calendar .react-datepicker__year-dropdown {
              height: 260px;
              max-height: 260px;
            }
            .personal-chat-calendar .react-datepicker__month-option,
            .personal-chat-calendar .react-datepicker__year-option {
              padding: 6px 12px;
              cursor: pointer;
              font-size: 14px;
              border-radius: 4px;
              outline: none;
              color: #1D2951;
            }
            .personal-chat-calendar .react-datepicker__month-option:focus,
            .personal-chat-calendar .react-datepicker__year-option:focus {
              outline: none;
              box-shadow: none;
            }
            .personal-chat-calendar .react-datepicker__month-option:hover,
            .personal-chat-calendar .react-datepicker__year-option:hover {
              background-color: #f3f4f6;
            }
            .personal-chat-calendar .react-datepicker__month-option--selected,
            .personal-chat-calendar .react-datepicker__year-option--selected {
              background-color: #1D2951;
              color: white;
            }
            .personal-chat-calendar .react-datepicker__day-names {
              display: flex;
              justify-content: space-around;
              margin-bottom: 8px;
              padding-top: 8px;
            }
            .personal-chat-calendar .react-datepicker__day-name {
              width: 36px;
              line-height: 36px;
              margin: 0;
              color: #6b7280;
              font-size: 12px;
              font-weight: 500;
              text-align: center;
            }
            .personal-chat-calendar .react-datepicker__month { margin: 0; padding: 0; }
            .personal-chat-calendar .react-datepicker__week {
              display: flex;
              justify-content: space-around;
              margin-bottom: 4px;
            }
            .personal-chat-calendar .react-datepicker__day {
              width: 34px;
              height: 34px;
              line-height: 36px;
              margin: 0;
              border-radius: 50%;
              color: #111827;
              font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .personal-chat-calendar .react-datepicker__day:hover {
              background-color: #f3f4f6;
              border-radius: 50%;
            }
            .personal-chat-calendar .react-datepicker__day--selected,
            .personal-chat-calendar .react-datepicker__day--keyboard-selected {
              background-color: #1D2951 !important;
              color: white !important;
              border-radius: 50%;
              font-weight: 500;
            }
            .personal-chat-calendar .react-datepicker__day--selected:hover,
            .personal-chat-calendar .react-datepicker__day--keyboard-selected:hover {
              background-color: #1D2951 !important;
            }
            .personal-chat-calendar .react-datepicker__day--today {
              font-weight: 600;
              border: 1px solid #1D2951;
              border-radius: 50%;
              box-sizing: border-box;
            }
            .personal-chat-calendar .react-datepicker__day--outside-month {
              color: #d1d5db;
            }
            .personal-chat-calendar .react-datepicker__day--disabled {
              color: #d1d5db;
              cursor: not-allowed;
            }
            .personal-chat-calendar .react-datepicker__navigation {
              top: 16px;
              outline: none;
              width: 32px;
              height: 32px;
              border-radius: 4px;
            }
            .personal-chat-calendar .react-datepicker__navigation:hover {
              background-color: #f3f4f6;
            }
            .personal-chat-calendar .react-datepicker__navigation:focus {
              outline: none;
              box-shadow: none;
            }
            .personal-chat-calendar .react-datepicker__navigation-icon::before {
              border-color: #111827;
              border-width: 2px 2px 0 0;
            }
          `}</style>
        </div>
      )}
    </div>
  );
};

export default PersonalChat;
